import { Component, PropsWithChildren } from "react";
import { injectIntl } from "react-intl";
import "cookieconsent";
import Template from "../layouts/Template";

import { intlShape } from "../shapes";
import Notification from "./Notification";

type Props = {
  intl?: intlShape;
  authenticated?: boolean;
};

type State = $TSFixMe;

export class Layout extends Component<PropsWithChildren<Props>, State> {
  constructor() {
    // @ts-expect-error TS(2554) FIXME: Expected 1-2 arguments, but got 0.
    super();
    /* istanbul ignore next */
    this.state = { cookieConsentVisible: false };
    this.notificationComponent = this.notificationComponent.bind(this);
  }

  componentDidMount() {
    const { intl } = this.props;
    (window as $TSFixMe).cookieconsent.initialise({
      position: "bottom",
      content: {
        href: "/legal/privacy-policy",
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        message: intl.formatMessage({ id: "cookie_consent.message" }),
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        link: intl.formatMessage({ id: "cookie_consent.link" }),
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        dismiss: intl.formatMessage({ id: "cookie_consent.dismiss" }),
      },
      onPopupOpen: () => {
        this.setState({ cookieConsentVisible: true });
      },
      onPopupClose: /* istanbul ignore next */ () =>
        this.setState({ cookieConsentVisible: false }),
    });
  }

  notificationComponent() {
    return this.props.authenticated ? (
      <div className="container">
        <Notification />
      </div>
    ) : null;
  }

  render() {
    const { children } = this.props;
    return (
      <Template
        cookieConsentVisible={this.state.cookieConsentVisible}
        notification={this.notificationComponent()}
      >
        {children}
      </Template>
    );
  }
}

// @ts-expect-error TS(2769) FIXME: No overload matches this call.
export default injectIntl(Layout);
